module.exports = __webpack_public_path__ + "static/img/5.1ab14b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/5.jpg
// module id = YyZh
// module chunks = 1